import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/general/verificationModal/VerificationModal.css";
import { FaShieldAlt, FaArrowRight, FaClock } from "react-icons/fa";

const VerificationModal = ({ show, onClose, type }) => {
  const navigate = useNavigate();

  if (!show) return null;

  const isStudent = type === "student";

  const config = {
    student: {
      title: "Student Verification",
      description: "Verify your identity to get full access to all features and increase your chances of receiving support.",
      verifyRoute: "/student/profile",
      skipRoute: "/student-login",
      color: "#7c3aed",
      icon: "🎓",
    },
    ngo: {
      title: "NGO Verification",
      description: "Verify your NGO to build trust with donors and unlock all platform features for maximum impact.",
      verifyRoute: "/ngo/Profile",
      skipRoute: "/ngo/dashboard",
      color: "#f97316",
      icon: "🤝",
    },
  };

  const current = config[type] || config.student;

  const handleVerify = () => {
    onClose();
    navigate(current.verifyRoute);
  };

  const handleSkip = () => {
    onClose();
    navigate(current.skipRoute);
  };

  return (
    <div className="vmodal-backdrop" onClick={onClose}>
      <div
        className="vmodal-container"
        onClick={(e) => e.stopPropagation()}
        style={{ "--accent": current.color }}
      >
        {/* Close Button */}
        <button className="vmodal-close" onClick={onClose}>×</button>

        {/* Top Icon */}
        <div className="vmodal-icon-wrap">
          <div className="vmodal-icon-ring">
            <span className="vmodal-emoji">{current.icon}</span>
          </div>
          <div className="vmodal-shield">
            <FaShieldAlt />
          </div>
        </div>

        {/* Content */}
        <div className="vmodal-body">
          <h2 className="vmodal-title">{current.title}</h2>
          <p className="vmodal-desc">{current.description}</p>

          {/* Benefits */}
          <div className="vmodal-benefits">
            <div className="vmodal-benefit-item">
              <span className="vmodal-check">✓</span>
              <span>Trusted & Verified Badge</span>
            </div>
            <div className="vmodal-benefit-item">
              <span className="vmodal-check">✓</span>
              <span>Full Platform Access</span>
            </div>
            <div className="vmodal-benefit-item">
              <span className="vmodal-check">✓</span>
              <span>Priority Support</span>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="vmodal-actions">
          <button className="vmodal-btn-verify" onClick={handleVerify}>
            <FaShieldAlt />
            <span>Verify Now</span>
            <FaArrowRight className="vmodal-arrow" />
          </button>

          <button className="vmodal-btn-skip" onClick={handleSkip}>
            <FaClock />
            <span>Skip for Now</span>
          </button>
        </div>

        <p className="vmodal-note">
          You can always complete verification later from your profile.
        </p>
      </div>
    </div>
  );
};

export default VerificationModal;